/* eslint-disable no-unused-vars, react/jsx-no-undef, arrow-parens */
import React from 'react';
import { FixedSizeList } from 'react-window';
import CheckBoxItem from 'shared/components/CheckBoxItem';
import { modifyRegionNameToDisplay } from 'shared/utils/awsUtils';

const renderRow = (props) => {
  const { index, style, data } = props;
  const item = data.preparedList[index];
  const { groupBy } = data;
  item.name = modifyRegionNameToDisplay(groupBy, item.name);
  return <CheckBoxItem style={{ ...style, textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} ContainerProps={item} />;
};


const InfiniteList = (props) => {
  const { preparedList, groupBy = null } = props;
  const itemData = { preparedList, groupBy };

  return (
    <div>
      <FixedSizeList itemData={itemData} height={300} width="auto" itemSize={30} itemCount={preparedList.length}>
        {renderRow}
      </FixedSizeList>
    </div>
  );
};


export default InfiniteList;
